import { renderElement } from "../../utils/use-render.js";
import { useTooltipContext } from "./context.js";
import { forwardRef, useCallback } from "react";
//#region src/ui/tooltip/trigger.tsx
/** Element that triggers the tooltip on hover and focus. Renders a `<button>` element. */
const TooltipTrigger = forwardRef(function TooltipTrigger({ render, className, style, ...elementProps }, forwardedRef) {
	const { tooltip, state, stateAttrMap } = useTooltipContext();
	const triggerRef = useCallback((el) => {
		tooltip.setTriggerElement(el);
	}, [tooltip]);
	const { onFocusIn, onFocusOut, ...restTriggerProps } = tooltip.triggerProps;
	return renderElement("button", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: [forwardedRef, triggerRef],
		props: [
			{ type: "button" },
			{
				...restTriggerProps,
				onFocus: onFocusIn,
				onBlur: onFocusOut
			},
			elementProps
		]
	});
});
//#endregion
export { TooltipTrigger };

//# sourceMappingURL=trigger.js.map